import Moment from "react-moment";
import { useEffect, useState } from "react";
import Station from "./components/Station";
import Toastify from "toastify-js";

import fetchSiteStations from "../../services/fetchSiteStations";
import fetchVisitsIn from "../../services/fetchVisistsIn";
import { useSelector } from "react-redux";
import fetchDateVisitsPrevIn from "../../services/fetchDateVisistsPrevIn";
import fetchDateVisitsPrevOut from "../../services/fetchDateVisistsPrevOut";
import WidgetTI from "./components/WidgetTI";
import WidgetTR from "./components/WidgetTR";
import fetchDateVisitsCurrOut from "../../services/fetchDateVisistsCurrOut";
import WidgetTO from "./components/WidgetTO";
import WidgetTT from "./components/WidgetTT";
import fetchDateVisitsCurrIn from "../../services/fetchDateVisistsCurrIn";
import WidgetPI from "./components/WidgetPI";
import WidgetPO from "./components/WidgetPO";
import { timeLap } from "../../utils/timeLap";
import fetchVisitsOut from "../../services/fetchVisistsOut";
import { pusher } from "../..";

export default function Welcome() {
  const { selectedSite } = useSelector((state: any) => state.site);
  const [isLoading, setLoading] = useState(false);
  const [newVisits, setNewVisits] = useState<any>([]);
  const [startDate, setStateDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [stations, setStations] = useState<any>([]);
  const [scanedin, setScannedin] = useState("");
  const [scanedout, setScannedout] = useState("");
  const [scanned, setScanned] = useState(true);
  const [sout, setSout] = useState(true);
  const [prevInVehicles, setPrevInVehicles] = useState<any>([]);
  const [prevOutVehicles, setPrevOutVehicles] = useState<any>([]);

  const [currInVehicles, setCurrInVehicles] = useState<any>([]);
  const [currOutVehicles, setCurrOutVehicles] = useState<any>([]);

  const [isPrevInLoading, setPrevInLoading] = useState(false);
  const [isPrevOutLoading, setPrevOutLoading] = useState(false);
  const [isCurrInLoading, setCurrInLoading] = useState(false);
  const [isCurrOutLoading, setCurrOutLoading] = useState(false);

  const site_id = selectedSite?._id || "6224dcf60c5c49d9fec9218f";

  const handleFetchVisitsIN = async () => {
    setLoading(true);
    const data = await fetchVisitsIn(site_id);
    const novehicle = data?.filter((visit: any) => visit?.vehicle !== null);
    const filtered = novehicle.filter(
      (visit: any) =>
        visit?.timein !== visit?.timeout &&
        timeLap(visit?.timein, visit?.timeout).trim() != "0 sec"
    );
    setNewVisits(filtered);
    setScanned(true);
    setTimeout(() => blinkin(), 5000);
    setLoading(false);
  };

  const handleFetchVisitsOUT = async () => {
    setLoading(true);
    const data = await fetchVisitsOut(site_id);
    const novehicle = data?.filter((visit: any) => visit?.vehicle !== null);
    const filtered = novehicle.filter(
      (visit: any) =>
        visit?.timein !== visit?.timeout &&
        timeLap(visit?.timein, visit?.timeout).trim() != "0 sec"
    );

    setSout(true);
    setTimeout(() => {
      blinkout();
      setNewVisits(filtered);
    }, 5000);
    setLoading(false);
  };

  const blinkin = () => {
    setScanned(false);
  };

  const blinkout = () => {
    setSout(false);
  };

  const handleFetchDateVisitsPrevIn = async () => {
    setPrevInLoading(true);
    const data = await fetchDateVisitsPrevIn(site_id, startDate, endDate);
    const novehicle = data?.payload.filter(
      (visit: any) => visit?.vehicle !== null
    );
    const filtered = novehicle.filter(
      (visit: any) =>
        visit?.timein !== visit?.timeout &&
        timeLap(visit?.timein, visit?.timeout).trim() != "0 sec"
    );

    setPrevInVehicles(filtered);
    setPrevInLoading(false);
  };

  const handleFetchDateVisitsPrevOut = async () => {
    setPrevOutLoading(true);
    const data = await fetchDateVisitsPrevOut(site_id, startDate, endDate);
    const novehicle = data?.payload.filter(
      (visit: any) => visit?.vehicle !== null
    );
    const filtered = novehicle.filter(
      (visit: any) =>
        visit?.timein !== visit?.timeout &&
        timeLap(visit?.timein, visit?.timeout).trim() != "0 sec"
    );
    setPrevOutVehicles(filtered);
    setPrevOutLoading(false);
  };

  const handleFetchDateVisitsCurrIn = async () => {
    setCurrInLoading(true);
    const data = await fetchDateVisitsCurrIn(site_id, startDate, endDate);
    const novehicle = data?.payload.filter(
      (visit: any) => visit?.vehicle !== null
    );
    const filtered = novehicle.filter(
      (visit: any) =>
        visit?.timein !== visit?.timeout &&
        timeLap(visit?.timein, visit?.timeout).trim() != "0 sec"
    );
    setCurrInVehicles(filtered);
    setCurrInLoading(false);
  };

  const handleFetchDateVisitsCurrOut = async () => {
    setCurrOutLoading(true);
    const data = await fetchDateVisitsCurrOut(site_id, startDate, endDate);
    const novehicle = data?.payload?.filter(
      (visit: any) => visit?.vehicle !== null
    );
    const filtered = novehicle.filter(
      (visit: any) =>
        visit?.timein !== visit?.timeout &&
        timeLap(visit?.timein, visit?.timeout).trim() != "0 sec"
    );

    setCurrOutVehicles(filtered);
    setCurrOutLoading(false);
  };

  const handleFetchStations = async () => {
    setLoading(true);
    const data = await fetchSiteStations(site_id);
    setStations(data?.payload?.stations);
    setLoading(false);
  };

  useEffect(() => {
    handleFetchVisitsIN();
    handleFetchStations();
    handleFetchDateVisitsPrevIn();
    handleFetchDateVisitsPrevOut();
    handleFetchDateVisitsCurrIn();
    handleFetchDateVisitsCurrOut();

    const scan = pusher.subscribe(`visit`);
    scan.bind("in", function (data: any) {
      setScannedin(data?.payload?.vehicle);
      handleFetchVisitsIN();
      handleFetchStations();
      handleFetchDateVisitsPrevIn();
      handleFetchDateVisitsPrevOut();
      handleFetchDateVisitsCurrIn();
      handleFetchDateVisitsCurrOut();

      Toastify({
        text: `${data?.payload?.vehicle}`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "#16A34A",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    scan.bind("out", function (data: any) {
      handleFetchVisitsOUT();
      handleFetchStations();
      handleFetchDateVisitsPrevIn();
      handleFetchDateVisitsPrevOut();
      handleFetchDateVisitsCurrIn();
      handleFetchDateVisitsCurrOut();
      setScannedout(data?.payload?.vehicle);

      Toastify({
        text: `${data?.payload?.vehicle}`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "red",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    return () => {
      pusher.unsubscribe("visit");
    };
  }, [selectedSite]);

  return (
    <div className="p-4  bg-gray-100">
      <div className="grid grid-cols-12 mb-4">
        <div className="col-span-12 sm:col-span-6 mb-2  sm:border-r  border-gray-300 px-4 py-2 bg-white rounded-lg sm:rounded-l-lg">
          <div className="text-center mb-2"> Today's Vehicles</div>
          <div className="grid grid-cols-6 gap-x-3 mb-4">
            <WidgetTT
              currInVehicles={currInVehicles}
              currOutVehicles={currOutVehicles}
              isLoading={isCurrInLoading}
            />
            <WidgetTO
              currOutVehicles={currOutVehicles}
              isLoading={isCurrOutLoading}
            />
            <WidgetTI
              currInVehicles={currInVehicles}
              isLoading={isCurrInLoading}
            />
          </div>
        </div>
        <div className="col-span-12 md:col-span-4 mb-2  sm:border-r border-gray-300 px-4 py-2 bg-white rounded-lg sm:rounded-l-lg">
          <div className="text-center mb-2"> Previous Vehicles</div>

          <div className="grid grid-cols-4 gap-x-3">
            <WidgetTR
              prevInVehicles={prevInVehicles}
              currInVehicles={currInVehicles}
              isLoading={isPrevInLoading}
            />
            <WidgetPO
              prevOutVehicles={prevOutVehicles}
              isLoading={isPrevOutLoading}
            />
          </div>
        </div>

        <div className="col-span-12 md:col-span-2 mb-2 border-gray-300 px-4 py-2 bg-white rounded-lg sm:rounded-r-lg">
          <div className="text-center mb-2"> All Vehicles</div>
          <div className="grid grid-cols-2 gap-x-3">
            <WidgetPI
              prevInVehicles={prevInVehicles}
              currInVehicles={currInVehicles}
            />
          </div>
        </div>
      </div>

      <div className="border rounded-md bg-white mb-4">
        <div className="border-b p-3 border-gray-300 mb-4 flex flex-row justify-between items-center">
          <div className="text-xl uppercase">
            <span className="font-bold">Today :</span> On Premises
          </div>
          <div className="flex flex-row">
            <div className="">
              <Moment format={"Do MMM YYYY"}>{new Date()}</Moment>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-2 px-4 pb-4 mb-2">
          {newVisits?.map((visit: any, index: number) => (
            <div
              className={`col-span-4 sm:col-span-6 md:col-span-1 bg-gray-100 ${
                scanedin == visit?.vehicle?._id
                  ? `animate__animated animate__flash animate__repeat-3 ${
                      scanned ? `bg-green-600 text-white` : ``
                    }`
                  : ``
              }
                ${
                  scanedout == visit?.vehicle?._id
                    ? `animate__animated animate__flash animate__repeat-3 ${
                        sout ? `bg-red-400 text-white` : ``
                      }`
                    : ``
                }`}
              key={index}
            >
              <div className="mx-2 py-3  font-bold text-sm text-center truncate">
                {visit?.vehicle?.registration}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-12 gap-2 bg-gray-100 h-auto">
        {stations?.map((station: any, index: number) => {
          if (station.name !== "Main Gate") {
            return <Station station={station} key={station._id} />;
          }
        })}
      </div>
    </div>
  );
}
